<template>
  <div>
    <div v-if="getAppMode">
      <div v-if="getAppMode === 'legal'">
        <CaseManager></CaseManager>
      </div>

      <div v-else-if="getAppMode === 'autoservice'">
        <AutoServiceDash></AutoServiceDash>
      </div>

      <div v-else-if="getAppMode === 'projects'">
        <ProjectsDash></ProjectsDash>
      </div>

      <div v-else-if="getAppMode === 'events'">
        <ProjectsDash></ProjectsDash>
      </div>

      <div v-else-if="getAppMode === 'privatePractice'">
        <HealthAndSocialDash></HealthAndSocialDash>
      </div>

      <div v-else-if="getAppMode === 'social'">
        <HealthAndSocialDash></HealthAndSocialDash>
      </div>

      <div v-else>
        <GeneralIndustryDashboard></GeneralIndustryDashboard>
      </div>
    </div>

    <div class="scrollable-container">
      <LoginOverLay
        :slug="slug"
        @login-completed="loginCompleted"
      ></LoginOverLay>
    </div>
  </div>
</template>

<script>
import companiesJs from "@/plugins/companies";
import Login from "@/modules/Auth/Login.vue";
import LoginWP from "@/modules/Auth/LoginWP.vue";
import LoginOverLay from "@/modules/Auth/LoginOverLay.vue";
import AutoServiceDash from "@/modules/AutoServices/AutoServiceDash.vue";
import CaseManager from "@/modules/CaseManager/CaseManager.vue";
import GeneralIndustryDashboard from "@/modules/GeneralIndustry/GeneralIndustryDashboard.vue";
import ProjectsDash from "@/modules/ProjectsIndustry/ProjectsDash.vue";
import HealthAndSocialDash from "@/modules/HealthAndSocialWork/HealthAndSocialDash.vue";

export default {
  name: "Dashboard",
  props: {
    slug: {
      type: String,
      default: "",
    },
  },
  watch: {
    slug: {
      immediate: true,
      handler(newVal) {
        this.getCompanyBySlug(newVal);
      },
    },
  },
  components: {
    Login,
    LoginWP,
    AutoServiceDash,
    CaseManager,
    GeneralIndustryDashboard,
    ProjectsDash,
    HealthAndSocialDash,
    LoginOverLay,
  },
  computed: {
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getAppMode() {
      return this.$store.getters.getAppMode;
    },
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  data: () => ({
    authenticated: false,
    overlay: false,
  }),
  updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  async mounted() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
    //this.authenticated = await this.$store.dispatch("isAuth");

    await this.initialiseDashboard();
  },
  methods: {
    async initialiseDashboard() {
      if (!this.getAuthenticated) {
        return;
      }
      await companiesJs.initialiseCompanyAndLogo();
    },
    loginCompleted() {
      window.location.reload();
    },
    async getCompanyBySlug(slug) {
      if (!slug) return;

      this.$store.commit("setLoader", true);
      const res = await companiesJs.getCompanyBySlug(slug);
      this.$store.commit("setLoader", false);

      if (res && res.status === "success") {
        const selectedCompany =
          res.company ||
          this.getSelectedDirectoryCompany ||
          this.getUserCompany ||
          null;
        if (selectedCompany) {
          this.$store.dispatch("setCompanyContext", {
            company: selectedCompany,
            fresh: false,
          });
        }
      }
    },
  },
};
</script>

<style scoped>
.scrollable-container {
  /* Limit the height to 90% of the viewport height */
  max-height: 90vh;

  /* Enable vertical scrolling when content exceeds max-height */
  overflow-y: auto;

  /* Optional: Ensure it centers nicely and handles padding */
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;

  /* --- HIDE SCROLLBAR --- */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

/* Chrome, Safari, and Opera */
.scrollable-container::-webkit-scrollbar {
  display: none;
}

/* Optional: Clean up scrollbar styling for a nicer look */
.scrollable-container::-webkit-scrollbar {
  width: 6px;
}
.scrollable-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
</style>
